<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="placeName" :placeholder="$t('lang.lab_placeName')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="selectPlaceList">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{$t('lang.lab_addPlace')}}</el-button>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 车位名称 -->
        <el-table-column prop="placeName" :label="$t('lang.lab_placeName')"></el-table-column>
        <!-- 车位面积 -->
        <el-table-column prop="placeArea" :label="$t('lang.lab_placeArea')"></el-table-column>
        <!-- <el-table-column prop="endDate" :label="$t('lang.lab_controlPeriod')" :formatter="parseDateFull">
        </el-table-column> -->
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button @click="changeTel(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="delTele(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
            <el-button class="orange" @click="transfer(scope.row)">{{$t('lang.lab_transfer')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item :label="$t('lang.lab_placeName')" prop="placeName">
          <el-input v-model="form.placeName" :placeholder="$t('lang.lab_placeName')" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_placeArea')" prop="placeArea">
          <el-input v-model="form.placeArea" :placeholder="$t('lang.lab_placeArea')" @input="keyPlaceArea"></el-input>
        </el-form-item>
         <el-form-item :label="$t('lang.lab_placeChildAndmother')" prop="review">
					<el-radio-group v-model="form.review">
						<el-radio v-for="(item,index) in reviewlist" :label="item.id" :key="index">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
      <!-- 转让弹框 -->
    <el-dialog :title="titleShow" :visible.sync="transferShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="ruleForm" :rules="rulesTransfer" ref="ruleForm" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 请选择园区 -->
        <el-form-item :label="$t('lang.lbl_fkgl_garden')" prop="gardenId">
          <el-select class="select" v-model="ruleForm.gardenId" @change="selectHouse" disabled>
            <el-option key :label="$t('lang.lab_selectVillage')" value="0"></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择楼号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_house')" prop="houseId">
          <el-select class="select" v-model="ruleForm.houseId" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value="0"></el-option>
            <el-option v-for="(item,index) in houseList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择单元号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_unit')" prop="unitId">
          <el-select v-model="ruleForm.unitId" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value="0"></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 请选择房间号 -->
        <el-form-item :label="$t('lang.lbl_fkgl_room')" prop="roomId">
          <el-select v-model="ruleForm.roomId">
            <el-option key :label="$t('lang.lab_roomName')" value="0"></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearTransfer()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="transferSave('ruleForm')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:添加车位
   *@author:xbz
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'
  
  export default {
    data() {
          var choosehouseId = (rule, value, callback) => {
            console.log(this.ruleForm)
          if (this.ruleForm.houseId === '' || this.ruleForm.houseId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.diaFormhouse')
              )
            )
          } else {
            callback()
          }
        }
        var chooseunitId = (rule, value, callback) => {
          if (this.ruleForm.unitId === '' || this.ruleForm.unitId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.diaFormunit')
              )
            )
          } else {
            callback()
          }
        }
        var chooseroomId = (rule, value, callback) => {
          if (this.ruleForm.roomId === '' || this.ruleForm.roomId === '0') {
            callback(
              new Error(
                this.$i18n.t('lang.lab_please_Select') +
                  this.$i18n.t('lang.lab_theRoomNum')
              )
            )   
          } else {
            callback()
          }
        }
      return {
        reviewlist: this.$i18n.t('lang.propertyManage.review'),
        gardenName: '',
        gardens: [], // 小区下拉列表
        houseList: [], // 楼号下拉列表
        unitList: [], // 单元下拉列表
        roomList: [], // 房间下拉列表
         ruleForm: {
          gardenId: this.$store.getters.gardenId, // 小区绑定值
          houseId: '0', // 楼号绑定值
          unitId: '0', // 单元绑定值
          roomId: '0', // 房间绑定值
        },
        transferShow: false,
				roomId: '',
        ownerId: '',
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          placeName: '',
          placeArea: '',
          endDate: '',
          id:'',
          review:0
        },
        placeName: '',
        rules: {
          placeName: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }],
          endDate: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input'),
            trigger: 'blur'
          }]
        },
        rulesTransfer: {
          houseId: [
            {
              required: true,
              validator: choosehouseId,
              trigger: 'change',
            },
          ],
          unitId: [
            {
            required: true,
              validator: chooseunitId,
              trigger: 'change',
            },
          ],
          roomId: [
            {
            required: true,
              validator: chooseroomId,
              trigger: 'change',
            },
          ]
      },
      }
    },
    // 初始化
    created() {
      this.ownerId = this.$route.query.row.id
			this.roomId = this.$route.query.row.roomId
      this.describe = this.$route.query.row.houseName+"-"+this.$route.query.row.unitName+"-"+this.$route.query.row.roomName
      this.selectPlaceList()
      this.getGArdens()
      this.selectHouse()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.selectPlaceList()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
       // 获取园区列表
      getGArdens() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
       // 通过小区选择楼号
      selectHouse() {
        this.type = 1
        this.ruleForm.houseId = '0'
        this.ruleForm.unitId = '0'
        this.ruleForm.roomId = '0'
        this.unitList = []
        this.roomList = []
        this.houseList = []
        this.gardenGrids(this.ruleForm.gardenId, 1)
      },
      // 通过楼号选择单元号
      selectUnit() {
        this.type = 2
        this.ruleForm.unitId = '0'
        this.ruleForm.roomId = '0'
        this.roomList = []
        this.unitList = []
        this.gardenGrids(this.ruleForm.houseId, 2)
      },
      // 通过单元选择房间号
      selectRoom() {
        this.roomList = []
        this.type = 3
        this.ruleForm.roomId = '0'
        this.gardenGrids(this.ruleForm.unitId, 3)
      },
      // 通过园区id查询楼号楼层房间号
      gardenGrids(gardenid, type) {
        if (gardenid == '0' || gardenid == '') {
          return
        }
        this.$get(
          `/gardenGrids?type=${type}&pageSize=999&pageNo=1&parentId=${gardenid}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (type === 1) {
                this.houseList = res.list
              } else if (type === 2) {
                this.unitList = res.list
              } else if (type === 3) {
                this.roomList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      keyPlaceArea() {
        this.form.placeArea = this.form.placeArea.replace(/[^\d.]/g, '')
      },
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      parseDateFull(row, column, cellValue, index) {
        var x = new Date(cellValue)
        var z = {
          y: x.getFullYear(),
          M: x.getMonth() + 1,
          d: x.getDate(),
          h: x.getHours(),
          m: x.getMinutes(),
          s: x.getSeconds(),
        }
        if (z.M < 10) {
          z.M = '0' + z.M
        }
        if (z.d < 10) {
          z.d = '0' + z.d
        }
        if (z.h < 10) {
          z.h = '0' + z.h
        }
        if (z.m < 10) {
          z.m = '0' + z.m
        }
        return z.y + '-' + z.M + '-' + z.d
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      selectPlaceList() {
        let loading = this.$loading()
        this.$get(
          `/carPlace?OwnerId=${this.ownerId}&placeName=${this.placeName}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 转让
      transfer(row) {
        this.form.placeName = row.placeName
        this.form.id = row.id
        this.titleShow = this.$i18n.t('lang.lab_transferPlace')
        this.transferShow = true
      },
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPlace')
        this.form.placeName = ''
        this.form.placeArea = ''
        this.form.review = 0
        this.form.id=''
        this.form.endDate = ''
        this.diaIsShow = true
      },
      changeTel(row) {
        debugger
        this.form.id=''
        this.editId = row.id
        this.titleShow = this.$i18n.t('lang.lab_changePark')
        this.form.placeName = row.placeName
        this.form.placeArea = row.placeArea
        this.form.review =row.isPlaceChildAndMother
        this.form.endDate = row.endDate
        this.saveData = JSON.stringify(this.form)
        this.diaIsShow = true
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`carPlace/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.selectPlaceList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                ownerId: this.ownerId,
								roomId: this.roomId,
                placeName: this.form.placeName,
                placeArea: this.form.placeArea,
                IsPlaceChildAndMother: this.form.review
              }
              let loading = this.$loading()
              console.log(params)
              this.$post(`/carPlace/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.selectPlaceList()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                placeName: this.form.placeName,
                placeArea: this.form.placeArea,
                IsPlaceChildAndMother: this.form.review
              }
              this.$patch(`/carPlace/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.selectPlaceList()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },

      transferSave(formName) {
        var gId = this.ruleForm.gardenId
        var hId = this.ruleForm.houseId
        var uId = this.ruleForm.unitId
        var rId = this.ruleForm.roomId
				let gardenName = this.gardens.find(v => v.id == gId).name
        let houseName = this.houseList.find(v => v.id == hId).name
        let unitName = this.unitList.find(v => v.id == uId).name
        let roomName = this.roomList.find(v => v.id == rId).name
        var des =gardenName+":"+ this.describe+" 将车位"+this.form.placeName+"转让给 "+gardenName+":"+houseName+"-"+unitName+"-"+roomName
        this.$refs[formName].validate(valid => {
          if (valid) {
	            let loading = this.$loading()
							this.$postJson(`/transferCarLogs`, {
									'gardenId': this.ruleForm.gardenId,
                  'houseId': this.ruleForm.houseId,
                  'unitId': this.ruleForm.unitId,
                  'roomId': this.ruleForm.roomId,
                  'describe': des,
                  'operateId':this.$store.getters.userData.id,
                  'placeName':this.form.placeName,
                  'carPlaceId':this.form.id, 
                  'type':"2"
								})
								.then(res => {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.transferShow = false
									this.selectPlaceList()
									loading.close()
								}, err => {
									this.$message.error(err)
									loading.close()
								})
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      clearTransfer() {
        this.$refs.ruleForm.resetFields()
        this.form.houseId = '0'
        this.form.unitId = '0'
        this.form.roomId = '0'
      },
      jump() {
        this.$router.push({
          name: 'preHouseholdInfoManageList'
        })
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.selectPlaceList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.selectPlaceList()
      }
    }
  }
</script>

<style lang="scss">
</style>